import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';

import { MapContext } from '../map';
import { Api } from '../../utils/api';
import { mapGplaceFormattedLocationToConvelioPricingApiAddressType } from '../../utils/mappers';
import { getLowercasedAndTrimedString } from '../../utils/getters';
import { DEBOUNCE_TIME } from '../../utils/variables';

export const MapProvider = ({ children }) => {
  const [pickupLocation, setPickupLocation] = useState('');
  const [deliveryLocation, setDeliveryLocation] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [messageId, setMessageId] = useState(null);
  const [apiAnswer, setApiAnswer] = useState(null);

  const loadOptions = useCallback(
    _.debounce((inputValue, callback) => {
      Api.getGplaces(inputValue)
        .then((res) => callback(res?.data?.predictions))
        .catch((err) => console.log(err));
    }, DEBOUNCE_TIME),
    []
  );

  const isCitiesFilledOut =
    pickupLocation?.description && deliveryLocation?.description;
  const handleSelectOption = (location, setLocation) =>
    Api.getGplaceDetails(location?.place_id)
      .then((res) =>
        setLocation(() => ({
          ...location,
          formatted_location: res?.data?.result
        }))
      )
      .catch((err) => console.log(err));

  const onClickSearch = async () => {
    const from = mapGplaceFormattedLocationToConvelioPricingApiAddressType(
      pickupLocation.formatted_location
    );
    const to = mapGplaceFormattedLocationToConvelioPricingApiAddressType(
      deliveryLocation.formatted_location
    );

    //SHIPPING REQUEST ID
    const shippingRequestResponse = await Api.postShippingRequest(from, to);
    const shippingRequestId = shippingRequestResponse?.data?.shippingRequestId;
    //SHIPPING METHODS
    const shippingMethodsResponse = await Api.getShippingMethods(
      shippingRequestId
    );
    const freightMethod =
      shippingMethodsResponse?.data?.shippingMethods[0]?.name;

    Api.getApiPrice(from, to, null, freightMethod)
      .then((res) => {
        const response = getLowercasedAndTrimedString(
          res?.data?.instantPricing?.message
        );
        setApiAnswer(response);
        setMessageId('geolocalisationAvailableShippingOptionsMessage');
        setShowMessage(true);
      })
      .catch((err) => {
        const response = err;
        setApiAnswer(response);
        setMessageId('geolocalisationCustomQuoteMessage');
        setShowMessage(true);
      });
    return;
  };

  useEffect(() => {
    setShowMessage(false);
  }, [pickupLocation, deliveryLocation]);

  return (
    <MapContext.Provider
      value={{
        pickupLocation,
        deliveryLocation,
        setPickupLocation,
        setDeliveryLocation,
        showMessage,
        setShowMessage,
        messageId,
        setMessageId,
        apiAnswer,
        setApiAnswer,
        isCitiesFilledOut,
        onClickSearch,
        loadOptions,
        handleSelectOption
      }}
    >
      {children}
    </MapContext.Provider>
  );
};
